import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RouterLinks} from '../shared/constants';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {PaymentDetailsComponent} from './components/payment-details/payment-details.component';
import {NotificationSettingsComponent} from './components/notification-settings/notification-settings.component';
import {AccountComponent} from './account.component';
import { ReferralsComponent } from './components/referrals/referrals.component';
import { WalletComponent } from './components/wallet/wallet.component';

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      {path: '', redirectTo: RouterLinks.ChangePassword, pathMatch: 'full'},
      {path: RouterLinks.ChangePassword, component: ChangePasswordComponent},
      {path: RouterLinks.PaymentDetails, component: PaymentDetailsComponent},
      //{path: RouterLinks.Referrals, component: ReferralsComponent},
      {path: RouterLinks.Wallet, component: WalletComponent},
      {path: RouterLinks.NotificationSettings, component: NotificationSettingsComponent}
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {
}
